module.exports = __webpack_public_path__ + "static/media/postcard-review-1.d091486e.png";